const {
  GET_ALL_BONRECEPTION_REQUEST,
  GET_ALL_BONRECEPTION_SUCCESS,
  GET_ALL_BONRECEPTION_FAIL,
  ADD_BONRECEPTION_REQUEST,
  ADD_BONRECEPTION_SUCCESS,
  ADD_BONRECEPTION_FAIL,
  GET_BONRECEPTION_REQUEST,
  GET_BONRECEPTION_SUCCESS,
  GET_BONRECEPTION_FAIL,
  UPDATE_BONRECEPTION_REQUEST,
  UPDATE_BONRECEPTION_SUCCESS,
  UPDATE_BONRECEPTION_FAIL,
  DELETE_BONRECEPTION_REQUEST,
  DELETE_BONRECEPTION_SUCCESS,
  DELETE_BONRECEPTION_FAIL,
  ADD_RCARTICLE_REQUEST,
  ADD_RCARTICLE_SUCCESS,
  ADD_RCARTICLE_FAIL,
  GET_RCARTICLE_REQUEST,
  GET_RCARTICLE_SUCCESS,
  GET_RCARTICLE_FAIL,
  UPDATE_RCARTICLE_REQUEST,
  UPDATE_RCARTICLE_SUCCESS,
  UPDATE_RCARTICLE_FAIL,
  DELETE_RCARTICLE_REQUEST,
  DELETE_RCARTICLE_SUCCESS,
  DELETE_RCARTICLE_FAIL
} = require("../../actionTypes/Achat/BonReception");

function getAllBonReceptions(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_BONRECEPTION_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_BONRECEPTION_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_BONRECEPTION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getBonReception(state = { data: {} }, action) {
  switch (action.type) {
    case GET_BONRECEPTION_REQUEST:
      return { loading: true, data: {} };
    case GET_BONRECEPTION_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_BONRECEPTION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addBonReception(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_BONRECEPTION_REQUEST:
      return { loading: true, data: {} };
    case ADD_BONRECEPTION_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_BONRECEPTION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateBonReception(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_BONRECEPTION_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_BONRECEPTION_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_BONRECEPTION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteBonReception(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_BONRECEPTION_REQUEST:
      return { loading: true, data: {} };
    case DELETE_BONRECEPTION_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_BONRECEPTION_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addRCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_RCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_RCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_RCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getRCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case GET_RCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case GET_RCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_RCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateRCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_RCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_RCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_RCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteRCArticle(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_RCARTICLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_RCARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_RCARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addBonReception,
  getBonReception,
  updateBonReception,
  deleteBonReception,
  getAllBonReceptions,
  addRCArticle,
  getRCArticle,
  updateRCArticle,
  deleteRCArticle
};
